import NotifyService from "@/services/notify.service";

function parseErrorMessage(message) {
  if (typeof message === "string" && message.includes(".") && message.includes(":")) {
    const [errorCode, paramsString] = message.split(".");

    if (paramsString && paramsString.includes(":")) {
      const params = {};
      const paramPairs = paramsString.split(",");

      paramPairs.forEach((pair) => {
        const [key, value] = pair.split(":");

        if (key && value !== undefined) {
          params[key.toLowerCase()] = value;
        }
      });

      return { errorCode, params };
    }
  }

  return { errorCode: message, params: {} };
}

export function showNotifyError(error) {
  if (error.graphQLErrors?.length) {
    error.graphQLErrors.forEach((errorItem) => {
      const message = errorItem?.extensions?.message;

      if (!message) {
        NotifyService.notify({ type: "error" });

        return;
      }

      const messages = Array.isArray(message) ? message : [message];

      messages.forEach((code) => {
        const { errorCode, params } = parseErrorMessage(code);

        NotifyService.error(errorCode, params);
      });
    });
  } else {
    NotifyService.error();
  }
}
